const bundesligaContent = {
  preview: `The Bundesliga 2024/25 season has entered a fascinating new chapter following Bayern Munich's 
  period of absolute dominance. With Bayer Leverkusen's historic title win still fresh in memory, 
  the league has proven that genuine competition at the top is possible. Bayern seek to reclaim their 
  throne while Leverkusen defend under immense pressure.`,

  keyStories: [
    {
      title: "Leverkusen's Title Defense",
      desc: "Defending champions Bayer Leverkusen face the classic second-season challenge — can they maintain last year's incredible standards?"
    },
    {
      title: "Bayern's Response",
      desc: "The Bavarian giants have responded to their title loss with significant investment and a renewed determination to dominate."
    },
    {
      title: "Borussia Dortmund's Consistency",
      desc: "BVB remain a consistent top-four presence, capable of challenging on all fronts in the right circumstances."
    },
  ],

  titleContenders: ["Bayern Munich", "Bayer Leverkusen", "Borussia Dortmund", "RB Leipzig", "Stuttgart"],

  fullPreview: `
    <h3>Bundesliga 2024/25 — Complete Analysis</h3>
    <p>German football's top division has rediscovered its competitive spirit. The era of near-automatic 
    Bayern Munich titles appears to be ending, replaced by genuine multi-club competition that benefits 
    the entire league's global appeal.</p>
    
    <h3>PitchFacts Prediction</h3>
    <p>Bayern Munich's superior resources make them narrow title favorites, but Leverkusen's 
    team spirit and tactical quality under Alonso make them genuine contenders to retain.</p>
  `,
};

export default bundesligaContent;